import { useEffect, useRef } from 'react'

export const useHighlightsRestore = (containerId: string, onRestore: () => void) => {
  const hasInitializedRef = useRef(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    let observer: MutationObserver | null = null

    const tryRestore = () => {
      const container = document.getElementById(containerId)

      if (!container) {
        // Container not ready yet, retry
        timeoutId = setTimeout(tryRestore, 100)
        return
      }

      // Initial restore
      if (!hasInitializedRef.current) {
        onRestore()
        hasInitializedRef.current = true
      }

      // Watch for content changes (e.g., navigation to new question)
      let lastChildCount = container.children.length

      observer = new MutationObserver(mutations => {
        const currentChildCount = container.children.length

        const contentReplaced = mutations.some(mutation => {
          return (
            mutation.type === 'childList' &&
            mutation.removedNodes.length > 3 &&
            mutation.addedNodes.length > 3
          )
        })

        const significantChange = Math.abs(currentChildCount - lastChildCount) > 5

        if (contentReplaced || significantChange) {
          lastChildCount = currentChildCount
          hasInitializedRef.current = false
          onRestore()
          hasInitializedRef.current = true
        }
      })

      observer.observe(container, {
        childList: true,
        subtree: false,
      })
    }

    tryRestore()

    return () => {
      if (observer) observer.disconnect()
      if (timeoutId) clearTimeout(timeoutId)
      hasInitializedRef.current = false
    }
  }, [containerId, onRestore])
}
